module.exports = __webpack_public_path__ + "img/10_NSC_Anim_iPad_P.fc36717b.jpg";